import { NM_GATEWAY_PRODUCTION_URL } from '@landing-blocks/shared/constants/urls.js';

export const getLmsCohortNearest = async (profession: string, language: string): Promise<string> => {
    const url = new URL(`/proxy/pierce/lms/cohort/nearest/${profession}`, NM_GATEWAY_PRODUCTION_URL);

    url.searchParams.set('lang', language);

    const response = await fetch(url, {
        headers: { 'x-client-id': 'landing-pages via nm-gateway' },
    });

    if (!response.ok) {
        const responseErrorMessage = await response.text();

        throw new Error(responseErrorMessage);
    }

    const payload = await response.json();

    return payload.date_begin;
};
